import { theme } from 'styles';

export const fieldStyles = {
  marginBottom: '8px',
  '.MuiInputBase-root': {
    border: '1px solid #dddddd',
    borderRadius: '8px',
  },
  '.MuiInputBase-input': {
    fontSize: 18,
  },

  '.MuiInputBase-root.Mui-error': {
    border: `2px solid ${theme.palette.error.main}`,
    borderRadius: '8px',

    '.MuiInputBase-input': {
      border: 'none',
      boxSizing: 'border-box',
    },
  },

  [theme.breakpoints.down('desktop')]: {
    marginBottom: '8px',
    '.MuiInputBase-input': {
      fontSize: 18,
    },
  },
};

export const errorBoxStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  backgroundColor: '#FEECEC',
  borderRadius: '8px',
  padding: '10px 14px',
  marginBottom: '16px',
};
